import { ActionContext } from 'vuex'

import util from '@/utils/classToObject'
import actionsTypes from '@/store/all-action-types'
import types from './all-mutation-types'
import { IRootState, emptyAction, actionEnsure } from '@/store'
import { IUiState } from './state'
import { ErrorMessage } from '@/models/alo/ErrorMessage'
import { ExportCatalogType } from '@/enum/ExportCatalogType';

export class UiAction {   
    public [types.UI_CLOSE_SNACKBAR](context: ActionContext<IUiState, IRootState>) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_CLOSE_SNACKBAR)
            resolve()
        })
    }
    public [types.UI_SET_CONTENT_HEIGHT](context: ActionContext<IUiState, IRootState>,height:number) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_CONTENT_HEIGHT,height)
            resolve()
        })
    }    
    public [types.UI_ADD_SNACK_MESSAGE](context: ActionContext<IUiState, IRootState>,message:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_ADD_SNACK_MESSAGE  ,message)
            resolve()
        })
    }        
    public [types.UI_CLOSE_ERROR](context: ActionContext<IUiState, IRootState>) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_CLOSE_ERROR)
            resolve()
        })
    }
    public [types.UI_ERROR_MESSAGE](context: ActionContext<IUiState, IRootState>,error:ErrorMessage) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_ERROR_MESSAGE, error)
            resolve()
        })
    } 
    public [types.UI_SET_SEARCH_FLUX](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SEARCH_FLUX  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_FLUX_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_FLUX_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_FLUX_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_FLUX_BY  ,sort)
            resolve()
        })
    }
    public [types.UI_SET_SEARCH_PARTENAIRE](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SEARCH_PARTENAIRE  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_PARTENAIRE_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_PARTENAIRE_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_PARTENAIRE_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_PARTENAIRE_BY  ,sort)
            resolve()
        })
    }public [types.UI_SET_SEARCH_DATASOURCE](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SEARCH_DATASOURCE  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_DATASOURCE_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_DATASOURCE_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_DATASOURCE_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_DATASOURCE_BY  ,sort)
            resolve()
        })
    }
    public [types.UI_SET_SEARCH_FEEDDOWNLOAD](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SEARCH_FEEDDOWNLOAD  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_FEEDDOWNLOAD_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_FEEDDOWNLOAD_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_FEEDDOWNLOAD_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_FEEDDOWNLOAD_BY  ,sort)
            resolve()
        })
    }
    public [types.UI_SET_SEARCH_FLUXBUILDER](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SEARCH_FLUXBUILDER  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_FLUXBUILDER_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_FLUXBUILDER_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_FLUXBUILDER_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_FLUXBUILDER_BY  ,sort)
            resolve()
        })
    }
    public [types.UI_SET_SEARCH_META](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SEARCH_META  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_META_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_META_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_META_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_META_BY  ,sort)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // PERSONNE
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_PERSONNE](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SEARCH_PERSONNE  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_PERSONNE_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_PERSONNE_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_PERSONNE_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_PERSONNE_BY  ,sort)
            resolve()
        })
    }


    //////////////////////////////////////////////////////////////////
    // PROFIL_EXCLUSION
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_PROFIL_EXCLUSION](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SEARCH_PROFIL_EXCLUSION  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_PROFIL_EXCLUSION_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_PROFIL_EXCLUSION_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_PROFIL_EXCLUSION_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_PROFIL_EXCLUSION_BY  ,sort)
            resolve()
        })
    }


    //////////////////////////////////////////////////////////////////
    // GROUP_CARAC
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_GROUP_CARAC](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SEARCH_GROUP_CARAC  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_GROUP_CARAC_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_GROUP_CARAC_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_GROUP_CARAC_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_SORT_GROUP_CARAC_BY  ,sort)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // FILTER_META
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_FILTER_GROUPID](context: ActionContext<IUiState, IRootState>,filter:number) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_FILTER_GROUPID  ,filter)
            resolve()
        })
    }
    public [types.UI_SET_FILTER_DBNAME](context: ActionContext<IUiState, IRootState>,filter:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_FILTER_DBNAME  ,filter)
            resolve()
        })
    }
    public [types.UI_SET_FILTER_DBKEY](context: ActionContext<IUiState, IRootState>,filter:string) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_FILTER_DBKEY  ,filter)
            resolve()
        })
    }
    public [types.UI_SET_FILTER_TYPE](context: ActionContext<IUiState, IRootState>,filter:ExportCatalogType) {
        return new Promise<void>((resolve) => {
            context.commit(types.UI_SET_FILTER_TYPE  ,filter)
            resolve()
        })
    }
    
}

export default util.classToObject(UiAction)
